import { Component, Input, OnInit, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Image } from "angular-engine/model/api.model";

@Component({
    selector: 'imagePic',
    templateUrl: "image-picture.template.html",
    styleUrls: ['image-picture.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ImagePicture implements OnInit {
    @Input() images: any;//Image[];
    @Input() type: string;
    @Input() scrollTarget: any;
    @Input() noLazy: boolean;
    @Input() hasGradient: boolean;
    @Input() caption:any;
    public image:any;

    constructor(private el: ElementRef, protected ref: ChangeDetectorRef) {

    }

    ngAfterViewChecked() {
        if(this.el.nativeElement && this.images)
        {
            
            if(this.type)
            {
                this.image = this.images.find((obj) => { return obj.name == this.type });
            }
            else
            {
                
                const elementWidth = this.el.nativeElement.clientWidth;
                const elementHeight = this.el.nativeElement.clientHeight;
            
                if(elementWidth > elementHeight)
                {

                    const smallestImage = this.images.find((obj) => { 
                            const matches = obj.name.match(/thumb_([0-9]+)/);
                            if( matches && matches.length > 0)
                                return matches[1] < elementWidth;
                            
                            return false;
                    });

                    if(smallestImage)
                    {
                        this.image = smallestImage;
                    }
                    else
                    {
                        this.image = this.images.find((obj) => {
                            return obj.name == "thumb_416x"
                        });
                    }
                }
                else{
                    const smallestImage = this.images.find((obj) => { 
                        const matches = obj.size.match(/([0-9])+/g);
                        if( matches && matches.length > 0)
                            return matches[1] < elementHeight;
                        
                        return false;
                    });

                    if(smallestImage)
                    {
                        this.image = smallestImage;
                    }
                    else
                    {
                        this.image = this.images.find((obj) => {
                            return obj.name == "thumb_416x"
                        });
                    }
                }
            }
            
        }
        this.ref.detectChanges();
    }

    ngOnInit(): void {
        if (this.images){
            if (Array.isArray(this.images)){
                if (this.images.length < 1){
                    this.images = null;
                }  
            }
            else{
                this.images = null;
            }
        }
        /*if(typeof this.images == "undefined" || this.images == null || this.images.length == 0) {
            return;
        }

        if(typeof this.type != "undefined" && this.type != null) {
            let type = this.type;
            let typedImage = this.images.filter(function (e) {
                if (e.name == type) {
                    return e;
                }
            });

            if (typedImage.length > 0) {
                this.images = typedImage;
                return;
            }
        }

        this.images = this.images.filter(function(e){
            if(e.name.indexOf(("thumb")) > -1){
                return e;
            }
        });*/

    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/custom-image/image-picture.component.ts